/** Страницата с цени. Текстовете на плановете са в plans.ts. */
export default {
  nav: {
    home: "Начало",
  },
  eyebrow: "Цени",
  title: "Прости планове, кинематографични резултати",
  subtitle: "Започнете с 10 безплатни точки. Купете пакет точки, когато имате нужда от още — еднократно плащане, а не абонамент.",
  creditsRemaining_one: "Имате {{count}} оставаща точка",
  creditsRemaining_other: "Имате {{count}} оставащи точки",
  mostPopular: "Най-популярен",
  secureCheckout: "Сигурно плащане с карта · Еднократно плащане, без абонамент · 30-дневна гаранция за връщане на парите",
  custom: {
    badge: "Персонална цена",
    title: "Създайте свой план",
    intro:
      "Изберете сума между {{min}} и {{max}}. Получавате предимствата на най-високия план, който сумата достига, и точки по неговата тарифа. От {{studio}} отключвате предимствата на Studio.",
    priceLabel: "Вашата цена (€)",
    summary_one: "За <amount>{{amount}}</amount> получавате <credits>{{formatted}} точка</credits> с предимствата на {{level}}.",
    summary_other: "За <amount>{{amount}}</amount> получавате <credits>{{formatted}} точки</credits> с предимствата на {{level}}.",
    credits: "Точки",
    level: "Ниво на предимствата",
    included: "Включено",
    cta: "Започнете",
    errors: {
      invalid: "Въведете сума в евро, например 25 или 25,50.",
      range: "Въведете сума между {{min}} и {{max}}.",
    },
  },
};
